export function removeWhitespace(value: unknown) {
  return typeof value === "string" ? value.replace(/\s+/g, "") : value;
}
